export const getValidTrackingCoordinates = (location) => {
  if (
    !location ||
    !Number.isFinite(location.lat) ||
    !Number.isFinite(location.lng)
  ) {
    return null;
  }

  return {
    lat: location.lat,
    lng: location.lng,
  };
};
